import React from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import {CardMain, CardContent, SystemType, TopDivider} from './styles';
import {Divider}from '../../atoms';
import {colors} from '../../styles';

const statusColor = new Map([
  ['RED', colors.alarm.red],
  ['YELLOW', colors.alarm.yellow],
  ['BLACK', colors.alarm.black]
]);

const SystemCard = ({system: {type, status}, history}) => (
  <CardMain onClick={() => history.push(`system/${type}`)} >
    <CardContent>
      <TopDivider style={{borderColor: colors.primary, marginBottom: '6px'}}/>
      <SystemType>{type}</SystemType>
      <Divider style={{borderColor: statusColor.get(status), borderWidth: '6px'}}/>
    </CardContent>
  </CardMain>
);

SystemCard.propTypes = {
  system: PropTypes.object,
  history: PropTypes.object
};

export default withRouter(SystemCard);
